import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const officeApi = createApi({
  reducerPath: "office",
  tagTypes: ["Offices"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getOffices: builder.query({
      query: () => "api/v2/offices",
      transformResponse: (response: any) => {
        return response.offices;
      }
    })
  })
});

export const { useGetOfficesQuery } = officeApi;
